/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { API_URL } from "../Store";
import { RingingPhone } from "./svgs/RingingPhone";
import { IoAddOutline } from "react-icons/io5";

const Header = () => {
  const [inforModal, setInfoModal] = useState(false);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [verificationCode, setVerificationCode] = useState("");

  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };

  const handleMakeCall = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleVerificationCodeChange = (e) => {
    setVerificationCode(e.target.value);
  };

  const handleCloseModal = () => {
    setInfoModal(false);
    setCurrentStep(1);
  };

  const [formData, setFormData] = useState({
    // name: "",
    phoneNumber: "",
    // email: "",
    // country: "",
  });

  const [errorMessage, setErrorMessage] = useState("");

  const handleApiSubmit = async () => {
    if (
      // !formData.name ||
      !formData.phoneNumber
      // !formData.email ||
      // !formData.country
    ) {
      setErrorMessage("All fields are required.");
      return;
    }

    setErrorMessage("");

    try {
      const response = await fetch(`${API_URL}save-new-user`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to submit data");
      }

      console.log("Data submitted successfully");
      setCurrentStep(2);
      setFormData({
        name: "",
        phoneNumber: "",
        email: "",
        country: "",
      });
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    if (errorMessage) {
      const timeout = setTimeout(() => {
        setErrorMessage("");
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [errorMessage]);

  useEffect(() => {
    if (currentStep === 2) {
      const timer = setTimeout(() => {
        setInfoModal(false);
        setCurrentStep(1);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [currentStep]);

  return (
    <>
    <div>
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="navbar w-full max-w-none px-4 md:px-10 lg:px-16 xl:px-24 h-20 backdrop-blur-xl bg-[#040407]/80 border-b border-white/[0.06]"
      >
        <div className="navbar-start">
          <div className="font-bold text-white text-2xl"></div>
        </div>
        <div className="navbar-center lg:flex gap-8 text-sm font-medium text-slate-300"><a href="#agents" className="hidden md:block hover:text-white">AI Agents</a><a href="#features" className="hidden md:block hover:text-white">Features</a><img src="/logomk.png" alt="MK Solution" className="h-14 w-auto"/><a href="#workflow" className="hidden md:block hover:text-white">How It Works</a><a href="#faqs" className="hidden md:block hover:text-white">FAQ</a></div>
        <div className="navbar-end">
          {/* <div 
              onClick={() => setInfoModal(true)}
          className="relative p-0.5 inline-flex items-center justify-center font-bold overflow-hidden group rounded-lg mt-1">
            <span className="w-full h-full bg-gradient-to-br from-[#BF9FF4] via-[#8B4AFA] to-[#7B2FFB] group-hover:from-[#BF9FF4] group-hover:via-[#8B4AFA] group-hover:to-[#7B2FFB] absolute"></span>
            <span className="relative px-4 py-1.5 transition-all cursor-pointer ease-out bg-darkPurple rounded-lg group-hover:bg-opacity-0 duration-400">
              <span
                className="relative text-white"
            
              >
                Try Now
              </span>
            </span>
          </div> */}
        </div>
      </motion.div>

      {inforModal && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 backdrop-blur-sm flex justify-center items-center z-100"
        >
          <div className="max-h-full w-full max-w-xl overflow-y-auto sm:rounded-2xl bg-[#060119] min-h-[400px] flex flex-col justify-between">
            <div className="w-full">
              <div className="m-8 my-14 max-w-[400px] mx-auto">
                <div className="mb-8">
                  {currentStep === 1 && (
                    <h1 className="mb-4 text-3xl font-extrabold text-center text-white">
                      Initiate Your First Call
                    </h1>
                  )}
                  {currentStep === 2 && (
                    <h1 className="mb-4 text-3xl font-extrabold text-center text-white">
                      First Call Initiated ...
                    </h1>
                  )}
                  {currentStep === 1 && (
                    <p className="text-gray-200 text-center">
                      Please provide the necessary details to initiate a call.
                      You will need to enter the name, select the country, and
                      provide the phone number and email for the call to
                      proceed.
                    </p>
                  )}
                  {currentStep === 2 && (
                    <p className="text-gray-200 text-center">
                      A call has been initiated on the number you provided.
                      Please stay on the line while we connect you.
                    </p>
                  )}
                </div>
                <ul className="steps mt-5 flex justify-center space-x-4">
                  <li
                    className={`step ${
                      currentStep >= 1 ? "step-primary" : "step-secondary"
                    }`}
                  ></li>
                  <li
                    className={`step ${currentStep >= 2 ? "step-primary" : ""}`}
                  ></li>
                </ul>
                <AnimatePresence>
                  {currentStep === 1 && (
                    <motion.div
                      key="step1"
                      animate={{ opacity: 1, x: 0 }}
                      exit={{ opacity: 0, x: -50 }}
                      transition={{ duration: 0.2 }}
                      className="mt-5"
                    >


                      <div className="flex items-center space-x-2 mt-5 rounded-md">
          
                        <label className="input w-full input-bordered flex items-center gap-2 bg-black">
                          <span className="text-white">
                            <IoAddOutline />
                          </span>
                          <input
                            type="number"
                            className="grow  [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                            placeholder="Phone Number"
                            value={formData.phoneNumber}
                            required
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                phoneNumber: e.target.value,
                              })
                            }
                          />
                        </label>
                      </div>

                  
                    </motion.div>
                  )}

                  {currentStep === 2 && (
                    <motion.h2
                      key="step2"
                      initial={{ opacity: 0, x: 50 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.2, delay: 0.2 }}
                      className="text-2xl mt-5 font-bold text-center text-white"
                    >
                      <h1 className="text-sm font-medium text-gray-200 ">
                        Check Your phone . . .
                      </h1>
                      <div className="flex justify-center mt-10">
                        <motion.div
                          animate={{
                            rotate: [0, -0.5, 0.5, -0.5, 0.5, 0],
                          }}
                          transition={{
                            duration: 0.3,
                            repeat: Infinity,
                            repeatType: "loop",
                          }}
                        >
                          <RingingPhone className="" />
                        </motion.div>
                      </div>

                      {/* <div className="flex justify-center mt-4 rotate-12">
                    <RingingPhone  className=""/>
                  </div> */}
                    </motion.h2>
                  )}
                </AnimatePresence>
                {errorMessage && (
                  <p className="text-red-500 text-center mt-4">
                    {errorMessage}
                  </p>
                )}
                <div className="gap-3 mt-8 flex">
                  <button
                    className="p-3 bg-[#040115] hover:bg-white text-white hover:text-black transition-all border rounded-2xl w-full font-semibold"
                    onClick={handleCloseModal}
                  >
                    Close
                  </button>
                  {currentStep === 1 && (
                    <button
                      className="p-3 bg-[#8B4AFA] hover:bg-[#5f32ad] transition-all rounded-2xl text-white w-full font-semibold"
                      onClick={handleApiSubmit}
                    >
                      Make Call
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      </div>
    </>
  );
};

export default Header;
